import { styled } from 'styled-components';

import { VersionedRouterLink } from 'components/VersionedLink/VersionedRouterLink';
import { colors } from 'theme/theme';

export const CmsSocialSidebarContainer = styled.div`
  background-color: ${colors.white};
  position: relative;
  box-shadow: 0 0 6px rgb(0 0 0 / 30%);
  border-radius: 8px;
  margin-top: 72px;
  padding: 28px;
`;

export const CmsSocialSidebarRecentJobsContainer = styled.div`
  padding-bottom: 8px;
`;

export const CmsSocialSidebarTooltipContainer = styled.div`
  margin-top: 8px;
  display: flex;
  gap: 8px;
`;

const cmsSocialSidebarButtonContainerBase = `
  background-color: ${colors.calloutGrey};
  color: ${colors.lightContentGrey};
  border-radius: 32px;
  &:hover {
    color: ${colors.hoverBlue};
    background-color: ${colors.softBlue};
  }
`;

export const CmsSocialSidebarShareButtonContainer = styled.button`
  ${cmsSocialSidebarButtonContainerBase};
  padding: 8px;
`;

export const CmsSocialSidebarNewsletterButtonContainer = styled.button`
  ${cmsSocialSidebarButtonContainerBase};
  padding: 5px;
`;

export const CmsSocialSidebarCommentsButtonContainer = styled.button`
  ${cmsSocialSidebarButtonContainerBase};
  padding: 8px;
`;

export const CmsSocialSidebarFAQLinkContainerBase = styled(VersionedRouterLink)`
  ${cmsSocialSidebarButtonContainerBase};

  display: inline-flex;
  padding: 8px;

  a {
    line-height: 1;
  }
`;
